import { render, staticRenderFns } from "./PaperSimple.vue?vue&type=template&id=d76d7b0a&"
import script from "./PaperSimple.vue?vue&type=script&lang=js&"
export * from "./PaperSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports